const itens = [
  {
    title: 'Novidades',
    href: '#novidades',
    target: '',
    event: '',
    icon: null,
    active: false
  },
  {
    title: 'Usabilidade',
    href: '#usabilidade',
    target: '',
    event: '',
    icon: null,
    active: false
  },
  {
    title: 'Design',
    href: '#design',
    target: '',
    event: '',
    icon: null,
    active: false
  },
  {
    title: 'Arquitetura',
    href: '#arquitetura',
    target: '',
    event: '',
    icon: null,
    active: false
  },
  {
    title: 'Acessar',
    href: 'https://novoapp.tagplus.com.br/',
    target: '',
    event: '',
    btn: true,
    icon: 'far fa-sign-in',
    active: false
  },
  {
    title: 'Experimente Grátis',
    href: 'https://www.tagplus.com.br?ref=landing_beta_tagplus',
    target: '',
    event: '',
    btn: true,
    icon: null,
    active: false
  }
]
export {
 itens 
}
